import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

import { EntriesService } from '../../../features/admin/modules/features/entries/entries.service';
import type { Entry, Module } from '../../../features/admin/modules/modules.model';
import { fetchAllPages } from '../../utils/paging.util';

export interface ReviewDocumentsQuery {
  moduleId: Module['id'];
  filter: string;
  pageSize?: number;
}

@Injectable({ providedIn: 'root' })
export class ReviewDocumentsQueryService {
  readonly #entriesService = inject(EntriesService);

  loadAll(query: ReviewDocumentsQuery): Observable<readonly Entry[]> {
    const pageSize = query.pageSize ?? 50;
    return fetchAllPages(
      offset =>
        this.#entriesService.getEntries({
          moduleId: query.moduleId,
          offset,
          limit: pageSize,
          filter: query.filter,
          orderBy: { active: 'id', direction: 'asc' },
          applyQueryParams: false,
        }),
      pageSize
    );
  }
}
